import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { List } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import styled from 'styled-components';
import { getProductNameText, getProductNameTextFromApiName } from '../../adapters/getProductNameText';
import { sourceKeys } from '../../data/upgradeData/properties/sources';
import { StyledModal } from '../StyledModal';
import ActivationSuccessFooter from './ActivationSuccessFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  TRIAL
} = sourceKeys;
const StyledDiv = styled.div.withConfig({
  displayName: "ActivationSuccessModal__StyledDiv",
  componentId: "sc-1fs50pn-0"
})(["text-align:left;display:flex;flex-direction:column;"]);
const ActivationSuccessModal = ({
  ctaText,
  header,
  onSuccess = () => {},
  subText,
  type,
  showTrialLoadingState,
  showSubtitle,
  upgradeData,
  upgradeData: {
    upgradeProduct,
    apiName
  },
  featureData
}) => {
  const isTrialModal = type === TRIAL;
  const productLine = apiName ? apiName.split('-')[0] : upgradeProduct.split('-')[0];
  return /*#__PURE__*/_jsxs(StyledModal, {
    centered: true,
    size: "auto",
    use: "success",
    width: 600,
    "data-test-id": "activation-success-modal",
    children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetBottom: 10,
      offsetTop: 40,
      children: /*#__PURE__*/_jsx(Illustration, {
        name: featureData !== null && featureData !== void 0 && featureData.displayName ? 'errors/map' : 'success',
        width: 118
      })
    }), /*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "1000",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-600",
        textAlign: "center",
        color: "text-core-on-fill-default",
        children: header || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: isTrialModal ? 'upgrades.activationModal.trialStartTitle' : 'upgrades.activationModal.productTitle'
        })
      }), showSubtitle && /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(Text, {
          marginBlockStart: "400",
          marginBlockEnd: "200",
          color: "text-core-on-fill-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.activationModal.trialSubtitle"
          })
        }), /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          typography: "heading-50",
          color: "text-core-on-fill-default",
          children: apiName ? getProductNameTextFromApiName(apiName) : getProductNameText(upgradeProduct)
        })]
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: subText ? /*#__PURE__*/_jsx("p", {
        children: subText
      }) : /*#__PURE__*/_jsxs(StyledDiv, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.globalContentBlock.title"
        }), /*#__PURE__*/_jsxs(List, {
          styled: true,
          wrapChildren: true,
          children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "upgrades.activationModal.globalContentBlock.tryForFree",
            options: {
              productName: apiName ? getProductNameTextFromApiName(apiName) : getProductNameText(upgradeProduct)
            }
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.activationModal.globalContentBlock.getSupport"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.activationModal.globalContentBlock.browseHowTo"
          })]
        }),
        // ContentHub Launch: this copy not ready for initial launch
        productLine !== 'cms' && /*#__PURE__*/_jsx(FormattedMessage, {
          message: `upgrades.activationModal.dynamicContentBlock.${productLine}`
        })]
      })
    }), /*#__PURE__*/_jsx(ActivationSuccessFooter, {
      ctaText: ctaText,
      onSuccess: onSuccess,
      showTrialLoadingState: Boolean(showTrialLoadingState),
      upgradeData: upgradeData,
      featureName: featureData ? featureData.displayName : null
    })]
  });
};
export default ActivationSuccessModal;